<template>
  <div
    class="maintenance-overlay"
    role="alert"
    aria-live="assertive"
  >
    <div class="maintenance-overlay__content">
      <div class="maintenance-overlay__icon">
        &#128295;
      </div>
      <h1 class="maintenance-overlay__title">
        We&rsquo;ll be right back
      </h1>
      <p class="maintenance-overlay__message">
        We&rsquo;re currently performing scheduled maintenance to improve your
        experience. Please check back shortly &mdash; thanks for your patience!
      </p>
    </div>
  </div>
</template>

<script>
// Vue 2 has no built-in <Teleport>, so this component re-parents its own
// root element onto <body> in mounted(). Combined with position: fixed and
// a maxed-out z-index, that guarantees it renders above every other UI
// element regardless of where <MaintenanceOverlay /> is placed in the tree.
export default {
  name: 'MaintenanceOverlay',
  mounted() {
    document.body.appendChild(this.$el);
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.maintenance-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(17, 17, 17, 0.96);
  color: #ffffff;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
}

.maintenance-overlay__content {
  max-width: 480px;
}

.maintenance-overlay__icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.maintenance-overlay__title {
  font-size: 24px;
  margin: 0 0 12px;
  font-weight: 600;
}

.maintenance-overlay__message {
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  color: #cccccc;
}
</style>
